import { useLayoutEffect, useState } from 'react';

import { Link, Typography } from '@mui/material';
import { Navigate, useNavigate } from 'react-router';

import Button from '@/components/Buttons/Button';
import GoLogo from '@/components/GoLogo';
import { spacing } from '@/constants/ui';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { BaseLayout } from '@/layouts/BaseLayout';
import { CenteredLayout } from '@/layouts/CenteredLayout';
import { useGxTokenFromStorage, useTripTokenFromStorage } from '@/services/storage';
import { logout } from '@/slices/authSlice';
import { clearSelection } from '@/slices/symbolSelectorSlice';

const Logout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const tripToken = useTripTokenFromStorage();
  const gxToken = useGxTokenFromStorage();
  const [wasLoggedInOnMount] = useState(Boolean(gxToken || tripToken));

  useLayoutEffect(() => {
    if (wasLoggedInOnMount) {
      dispatch(clearSelection());
      dispatch(logout());
    }
  }, [wasLoggedInOnMount, dispatch]);

  if (!wasLoggedInOnMount) {
    return (
      <Navigate
        replace
        to='/login'
      />
    );
  }
  return (
    <BaseLayout>
      <CenteredLayout>
        <GoLogo size={74} />
        <Typography
          sx={{
            mt: spacing[4]
          }}
          variant='h1'
        >
          You've been logged out.
        </Typography>
        <Typography
          sx={{ my: spacing[2], fontWeight: 500 }}
          variant='subtitle1'
        >
          Please log back in.
        </Typography>
        <Button
          sx={{
            width: 250,
            mb: spacing[3]
          }}
          variant='contained'
          onClick={() => {
            navigate('/login');
          }}
        >
          Go to Login
        </Button>
        <Typography>
          Any issues? Drop us a line at{' '}
          <Link
            color='text.primary'
            href='mailto:support@general-index.com'
            target='_top'
          >
            support@general-index.com
          </Link>
        </Typography>
      </CenteredLayout>
    </BaseLayout>
  );
};

export default Logout;
